import Chip, { ChipProps } from '../../ui/Chip'

const LargeChip = ({
  color,
  label,
  url,
  icon,
  onClick,
  style,
  medium, // makes it a bit smaller lol
}: {
  color: 'default' | 'primary' | 'secondary' | 'info' | 'success'
  label: string
  url?: string
  onClick?: () => void
  icon: ChipProps['icon']
  style?: ChipProps['style']
  medium?: boolean
}) => {
  return (
    <Chip
      color={color}
      label={label}
      clickable
      size="medium"
      onClick={onClick || (() => window.open(url, '_blank'))}
      icon={icon}
      style={style}
      className={
        medium
          ? 'h-auto rounded-[1.25rem] px-1 py-1 text-[1.1rem]'
          : 'h-auto rounded-2xl px-4 py-2 text-xl'
      }
    />
  )
}

export default LargeChip
